export default __webpack_public_path__ + "static/media/placeholder-secret.c734fb26.svg";